// extracted by mini-css-extract-plugin
export var actionCtaButton = "BoxSubscriptionPanel_actionCtaButton__b0wA4";
export var centered = "BoxSubscriptionPanel_centered__cOnqg";
export var checkoutDescription = "BoxSubscriptionPanel_checkoutDescription__DIp8X";
export var closedMsg = "BoxSubscriptionPanel_closedMsg__VNSxd";
export var container = "BoxSubscriptionPanel_container__6tjow";
export var customizationsHeader = "BoxSubscriptionPanel_customizationsHeader__BwC2D";
export var customizationsSection = "BoxSubscriptionPanel_customizationsSection__kuzdG";
export var description = "BoxSubscriptionPanel_description__zSMrV";
export var editLink = "BoxSubscriptionPanel_editLink__1sxLK";
export var errorMessage = "BoxSubscriptionPanel_errorMessage__eweLv";
export var errorState = "BoxSubscriptionPanel_errorState__PAgVZ";
export var freeShipping = "BoxSubscriptionPanel_freeShipping__6GDPb";
export var loadingState = "BoxSubscriptionPanel_loadingState__Dn8RD";
export var manageSubscription = "BoxSubscriptionPanel_manageSubscription__-cXot";
export var manageSubscriptionContainer = "BoxSubscriptionPanel_manageSubscriptionContainer__vwukg";
export var noMargin = "BoxSubscriptionPanel_noMargin__ZjuZa";
export var open = "BoxSubscriptionPanel_open__0c+E4";
export var panelContainer = "BoxSubscriptionPanel_panelContainer__Mf1I9";
export var productBrand = "BoxSubscriptionPanel_productBrand__NyzrV";
export var productDescription = "BoxSubscriptionPanel_productDescription__+f8b5";
export var productDetails = "BoxSubscriptionPanel_productDetails__3Xt8F";
export var productGrid = "BoxSubscriptionPanel_productGrid__YlXHm";
export var productGridWrapper = "BoxSubscriptionPanel_productGridWrapper__+wPAv";
export var productImage = "BoxSubscriptionPanel_productImage__ThcTM";
export var productItem = "BoxSubscriptionPanel_productItem__aoC4x";
export var productMeta = "BoxSubscriptionPanel_productMeta__8MRz2";
export var productName = "BoxSubscriptionPanel_productName__FRrHP";
export var retryButton = "BoxSubscriptionPanel_retryButton__ZMiJJ";
export var reviewSubscriptions = "BoxSubscriptionPanel_reviewSubscriptions__u5xU7";
export var status = "BoxSubscriptionPanel_status__vxSt6";
export var statusContainer = "BoxSubscriptionPanel_statusContainer__wPiLS";
export var statusLight = "BoxSubscriptionPanel_statusLight__JBlAq";
export var summaryDetails = "BoxSubscriptionPanel_summaryDetails__wWcBw";
export var title = "BoxSubscriptionPanel_title__6B0sg";
export var titleContainer = "BoxSubscriptionPanel_titleContainer__O3Oks";